import makeRequest from "../api/makeRequest";
import url from "../api/urls";

export default class CallService {
    static async refreshCallLog(id: string) {
        return await makeRequest(url.callLogs.syncCallRecordings + "/" + id, "GET");
    }
}